import React, { Component } from "react";

export default class AboutPages extends Component {
  render() {
    return (
      <section className="container">
        <div className="centertext">
          <h1 className="title">Lidt om os</h1>
          <div className="content-text">
            Vi er en af ​​de bedste pizza takeaway restauranter med
            leveringstjeneste på Vesterbro. <br />
            På vores menu finder du et udvalg af forskellige pizzaer med mange
            variationer af fyld. <br />
            Lyst til en krydret pizza, så prøv for eksempel vores mexicanske
            pizza Zorro med tomat, <br />
            ost, bacon, pepperoni, jalapenos. Er du mere til en vegetar pizza,
            så prøv <br />
            vores pizza kaldet Artiskok, som er med tomat, ost, champignon,
            paprika, løg, artiskok, hvidløg.
            <br />
            Vi serverer også andre retter, såsom kebab og burger. Mulighederne
            er mange hos <br />
            OS! Vores hjemmelavet pizza sandwich er altid populærere, de <br />
            serveres med forskelligt fyld, her kan blandt andet nævnes, kylling,
            kebab, græskbøf, falafel <br />
            og meget mere.
          </div>
        </div>
      </section>
    );
  }
}
